import {formatBalance} from "../utils";
import {Button} from "../components/Button";
import {RoundedModal} from "../components/Modal";
import React, {useEffect} from "react";
import PurchaseButton from "../components/PurchaseButton";
import GetMoreGroveButton from "../components/GetMoreGroveButton";
import closePurple from "../assets/icons/modal/close-purple@2x.png";
import {useDispatch, useSelector} from "react-redux";
import UIState from "../store/uiState";
import Wallet, {selectCurrentAccount, selectNFTBalances, selectProvider} from "../store/models/wallet";
import cardNew from "../assets/icons/card/new@2x.png";
import cardSoldOut from "../assets/icons/card/sold-out@2x.png";
import cardExclusive from "../assets/icons/card/exclusive@2x.png";
import _ from "lodash";
import classNames from "classnames";
import tokenIcon from "../assets/logos/grove@2x.png";
import {ModalTypes} from "../constants";

export const AirdropModal = ({airdrop}) => {
    const dispatch = useDispatch();
    const currentAccount = useSelector(selectCurrentAccount);
    const airdropState = airdrop.state;
    const items = airdrop.items;
    const claimed = airdropState?.hasClaimed;
    const allowed = airdropState?.isAllowed;
    const [airdropStatus, setAirdropStatus] = React.useState(null);

    let buttonTitle = 'Claim';
    if (claimed) {
        buttonTitle = 'Claimed';
    } else if (!allowed) {
        buttonTitle = 'Not Eligible';
    }

    useEffect(() => {
        const fetchData = async () => {
            if (currentAccount) {
                dispatch(Wallet.actions.fetchClaimableAirdropStates());

                if(airdrop.isToken){
                    // Call the getAirdropStatus function on the airdrop.contract
                    const status = await dispatch(Wallet.actions.getAirdropStatus(airdrop.contract_address));
                    console.log('status == ', status);
                    setAirdropStatus(status);
                }
            }
        }
        fetchData()
    }, [currentAccount, airdrop.contract_address]);

    const onClaim = () => {
        if(airdrop.isToken){
            if(airdropStatus.claimed){
                dispatch(UIState.actions.showModal(ModalTypes.Stake, {
                    defaultAmountToStake: airdropStatus?.items[0].qty,
                }));
            }
            else{
                dispatch(Wallet.actions.claimAirDrop(airdrop.contract_address, airdrop.isToken, airdropStatus?.items[0].qty));
            }
        }
        else{
            // Just NFTs
            dispatch(Wallet.actions.claimAirDrop(airdrop.contract_address));
        }
    }

    const onClose = () => {
        console.log('close');
        dispatch(UIState.actions.hideModal());
    }

    return (
        <RoundedModal title={null}
                      header={<div>
                          <a onClick={onClose}
                             className={'AirdropModal__close'}
                          >
                              <img src={closePurple}/>
                          </a>
                      </div>}
                      className={classNames('AirdropModal', {
                          ['AirdropModal--claimable']: allowed && !claimed,
                          ['AirdropModal--claimed']: claimed,
                          ['AirdropModal--not-allowed']: !allowed,
                          ['AirdropModal--token-airdrop']: airdrop.isToken,
                      })}
        >
            <div className={'AirdropModal__image'}>
                <img src={`${airdrop.image}`}/>
            </div>
            <div className={'AirdropModal__name'}>
                {airdrop.name}
            </div>
            <div className={'AirdropModal__description'}>
                {airdrop.description}
            </div>
            {
                airdrop.isToken &&
                <div className={'AirdropModal__token-amount'}>
                    <img src={tokenIcon}/>
                    <span>
                        {formatBalance(airdropStatus?.items[0].qty)}
                    </span>
                </div>
            }
            <div className={'AirdropModal__items'}>
                {
                    items.map((item, index) => {
                        return (
                            <div className={'AirdropModal__item'}>
                                <img src={item.image}
                                     className={'AirdropModal__item__image'}
                                />
                                <div className={'AirdropModal__item__name'}>
                                    {item.name}
                                </div>
                            </div>
                        )
                    })
                }
            </div>
            {
                _.isNil(currentAccount) &&
                <Button className={'AirdropModal__connect-button'}
                        color={'red'}
                        size={'large'}
                        style={{width: '100%'}}
                        onClick={onClaim}
                >
                    Connect Wallet
                </Button>
            }
            {
                !_.isNil(currentAccount) &&
                <Button className={'AirdropModal__button'}
                        color={'red'}
                        size={'large'}
                        style={{width: '100%'}}
                        onClick={onClaim}
                >
                    {buttonTitle}
                </Button>
            }

        </RoundedModal>
    )
}

export default AirdropModal;